//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import { axiosGet, axiosPost } from '../../axios/axios'
import { formatTime } from '../../components/helpers.js'
import { ACTIONS, prepareRecord, getMaintenanceNoteStatusColor } from './ServiceObjectMaintenanceNote.js'
import ServiceObjectMaintenanceNoteBody from './ServiceObjectMaintenanceNoteBody.vue'
import ServiceObjectMaintenanceNoteOperation from './ServiceObjectMaintenanceNoteOperation.vue'

export default {
  components: {
    ServiceObjectMaintenanceNoteBody
  },
  props: {
    sourceProps: {
      type: Object,
      default: function () {
        return null
      }
    },
    multipleCreateServiceObjectIds: {
      type: Array,
      default: null
    }
  },
  data: function () {
    return {
      getMaintenanceNoteStatusColor: getMaintenanceNoteStatusColor,
      record: { },
      formatTime: formatTime,
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    mobile: function () {
      return this.$store.getters.getUser.view === 'mobile'
    },
    buttons: function () {
      return ACTIONS.filter(action => action.btn && (!action.displayFn || action.displayFn(this.record)))
    },
    createMode: function () {
      return this.$route.name === 'serviceObjectMaintenanceNoteCreate'
    },
    multipleCreate: function () {
      return this.multipleCreateServiceObjectIds && this.multipleCreateServiceObjectIds.length >= 1
    },
    access: function () {
      return true // role operation
    },
    serviceObjectId: function () {
      if (this.sourceProps && this.sourceProps.serviceObjectType !== 'stationMetro') {
        return this.sourceProps.serviceObjectId
      } else if (this.record.serviceObject) {
        return this.record.serviceObject.id
      }
      return null
    },
    serviceObjectType: function () {
      if (this.sourceProps && this.sourceProps.serviceObjectType !== 'stationMetro') {
        return this.sourceProps.serviceObjectType
      } else if (this.record.serviceObject) {
        return this.record.serviceObject.type
      }
      return null
    },
    serviceObjectName: function () {
      if (this.sourceProps && this.sourceProps.serviceObjectType !== 'stationMetro') {
        return this.sourceProps.serviceObjectName
      } else if (this.record.serviceObject) {
        return this.record.serviceObject.name
      }
      return null
    }
  },
  watch: {
    $route: {
      handler: function (router) {
        if (router.params.id && !this.createMode) {
          this.load(+router.params.id)
        } else {
          this.record = prepareRecord({})
        }
      },
      immediate: true
    }
  },
  methods: {
    onAction: function (action) {
      this.$d.dialog(this).show({
        maximized: false,
        persistent: true,
        headerHidden: true,
        contentComponent: ServiceObjectMaintenanceNoteOperation,
        contentProps: {
          recordId: this.record.id,
          record: this.record,
          action: action
        },
        componentHandlers: {
          cancel: () => {
          },
          update: () => {
            this.load()
          }
        }
      })
    },
    load: function (id = this.record.id) {
      this.loading = true
      return axiosGet({
        url: `/service/delta/journal/serviceobjectmaintenancenotes/get?id=${id}`,
        onSuccess: (response) => {
          this.record = prepareRecord(response.data.result)
        },
        onFailure: ''
      }).finally(() => {
        this.loading = false
      })
    },
    onClose: function () {
      if (window.history.length != 1 && window.history.state !== null) {
        this.$router.back()
      } else {
        this.$router.push('/')
      }
    },
    onSave: async function () {
      this.loading = true

      const result = await this.uploadFiles(this.record._filesGroup)
      let successFileIds = []
      if (result) {
        const filesLoad = result.results.filter(item => item.status !== 'rejected') || []
        successFileIds = filesLoad.map(item => {
          return item.value.data.id
        })
      }

      const formData = new FormData()
      if (this.record.id) {
        formData.set('id', this.record.id)
      }
      const selectedFromReportPhotos = this.record._filesGroup.files.filter(file => file.document.selectedFromReport).map(file => file.id)
      const properties = {
        maintenanceNoteTypeId: this.record.maintenanceNoteType ? this.record.maintenanceNoteType.id : null,
        description: this.record.description || null,
        photos: [...(this.record.photos || []), ...successFileIds, ...selectedFromReportPhotos] || null
      }

      if (this.createMode) {
        if (this.sourceProps) {
          properties.serviceObjectId = this.serviceObjectId
          properties.recordSource = this.sourceProps.recordSource // requestReport, serviceObject
          if (this.sourceProps.requestReportId) {
            properties.requestReportId = this.sourceProps.requestReportId
          }
        } else if (this.multipleCreate) {
          formData.set('objectIds', this.multipleCreateServiceObjectIds)
          properties.recordSource = 'multipleCreate'
        }
      }

      formData.set('properties', JSON.stringify(properties))

      const url = this.multipleCreate
        ? '/service/delta/journal/serviceobjectmaintenancenotes/multipleCreate'
        : '/service/delta/journal/serviceobjectmaintenancenotes/edit'

      return axiosPost({
        url: url,
        data: formData,
        onSuccess: (response) => {
          let msg = ''
          if (this.createMode) {
            if (this.multipleCreate) {
              const count = response.data.count
              msg = 'Успешно создано замечаний: ' + count + '/' + this.multipleCreateServiceObjectIds.length
              this.onClose()
            } else {
              msg = 'Запись создана'
              this.$router.replace({ name: 'serviceObjectMaintenanceNote', params: { id: response.data.id, sourceProps: this.sourceProps } })
            }
          } else {
            this.load(this.record.id)
            msg = 'Изменения сохранены'
          }
          this.$q.notify({
            type: 'positive',
            message: msg,
            progress: true,
            timeout: 3000
          })

          return response.data
        },
        onFailure: 'Ошибка изменения записи'
      }).finally(() => {
        this.loading = false
      })
    },
    uploadFiles: async function (filesGroup, notify = true) {
      try {
        return await filesGroup.uploadFiles({ notify, target: this })
      } catch (error) {
        throw new Error(error.message)
      }
    }
  }
}
